import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { isIOS } from '../utils/audioUtils';
import QuestionAudioPlayer from '../../shared/QuestionAudioPlayer';

const RecordedAudioPlayer = ({ audioUrl }) => {
  const { isDarkMode } = useTheme();
  if (!audioUrl) return null;

  return (
    <div className="mb-4 p-5 rounded-2xl border-2 bg-gradient-to-br from-blue-500/10 to-sky-500/5 border-blue-500/30 dark:from-blue-500/10 dark:to-blue-600/5 dark:border-blue-500/35 max-md:py-4 max-md:px-4 max-md:pb-9">
      <h3 className="m-0 mb-4 text-base font-semibold text-[var(--text-primary)] max-md:text-[15px] max-md:mb-3.5">
        Your Recording
      </h3>
      <QuestionAudioPlayer
        audioUrl={audioUrl}
        compact={false}
        showQuota={false}
        maxPlaysMode="unlimited"
        fullWidth={true}
      />
      {isIOS() && (
        <p
          className="text-sm mt-2 text-gray-500 dark:text-slate-400"
          style={{ marginTop: '8px', fontSize: '13px' }}
        >
          Tidak dengar suara? Di iPhone, pastikan tombol Silent (di samping) tidak ditekan.
        </p>
      )}
    </div>
  );
};

export default RecordedAudioPlayer;
